import { type FC } from 'react';
import { useOnMount } from '~/_shared/hooks/useOnMount';
import { useClientIdSelector } from '~/store/selectors/useClientIdSelector';
import { useToolCollapseState } from '../useToolCollapseState';
import { DataLayersToolComponent } from './dataLayersTool.component';

export const DataLayersToolContainer: FC = () => {
  const clientId = useClientIdSelector();
  const { isToolCollapsed } = useToolCollapseState();

  useOnMount(() => {
    if (!clientId) {
      return;
    }
    // getDemographicsListAGS(clientId).then(response =>
    // console.log('Fetched demographics AGS:', response)
    // );
  });

  return (
    <DataLayersToolComponent
      isLegendMode={isToolCollapsed}
    />
  );
};
